import {ImageModel} from "./ImageModel";

export class AnnexImageModel {
    annexId = 0;
    imageId = 0;
    sequence = 0;
    image = new ImageModel();
}